var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('downloadexcel',{attrs:{"fetch":_vm.getRelatos,"fields":_vm.json_fields,"name":"Relatos.xls","type":"xls"}},[_c('el-button',{attrs:{"type":"info","icon":"el-icon-download"}},[_vm._v("Exportar")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }